import { render, staticRenderFns } from "./OverdueAndInsolvent.vue?vue&type=template&id=5dc21cca&scoped=true&"
import script from "./OverdueAndInsolvent.vue?vue&type=script&lang=js&"
export * from "./OverdueAndInsolvent.vue?vue&type=script&lang=js&"
import style0 from "./OverdueAndInsolvent.vue?vue&type=style&index=0&id=5dc21cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc21cca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
